import Icon from 'components/base/Icon';
import { StyledCategoryToolBoxTitle } from './CategoriesList.style';
import { LBButton } from '@linearb/buzz';

const CategoryItemTitle = ({ category, onOrderUp, onOrderDown }) => {
  return (
    <StyledCategoryToolBoxTitle>
      <header>{category.name}</header>
      <aside>
        <LBButton
          variant='ghost'
          size='icon'
          onClick={onOrderUp}
          disabled={!onOrderUp}
        >
          <Icon name='ArrowRight' direction='right' />
        </LBButton>

        <LBButton
          onClick={onOrderDown}
          variant='ghost'
          size='icon'
          disabled={!onOrderDown}
        >
          <Icon name='ArrowRight' direction='left' />
        </LBButton>
      </aside>
    </StyledCategoryToolBoxTitle>
  );
};

export default CategoryItemTitle;
